import type { CustomRenderer } from '@glideapps/glide-data-grid';

import { Render as defaultTickerCell } from './Ticker';

import type { TickerCell } from './types';

export const createTickerCell = (
  customTickerCell: Pick<
    CustomRenderer<TickerCell>,
    'provideEditor' | 'onPaste'
  >
): CustomRenderer<TickerCell> => {
  return {
    ...defaultTickerCell,
    ...customTickerCell,
  };
};
